import { WithUserNamespace } from '../../state/user';
import { isUserLoggedIn } from './pureSelectors';

export const getLoggedInUser = (state: WithUserNamespace) =>
    (isUserLoggedIn(state) && state?.user) || null;
